/* eslint-disable max-len */
import {SERVICE_NAMES} from '../constants';
import {createApiCall} from '../utils';
import type {ServiceName} from '../constants';
import type {
    ApiCallOptions,
    SignatureApiResponse,
    StoreSignatureRequest,
    SignatureResource
} from './api.d';

const createSignatureApiCall = <T = any>(
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    endpoint: string
) => createApiCall<T>(SERVICE_NAMES.SIGNATURE as ServiceName, method, endpoint);

export const signatureApi = {
    getSignature: (userId: string, options?: ApiCallOptions) =>
        createSignatureApiCall<SignatureApiResponse>('GET', `users/${userId}/signature`)({...options}),

    storeSignature: (userId: string, data: StoreSignatureRequest, options?: ApiCallOptions) => {
        const formData = new FormData();
        formData.append('image_signature', data.image_signature);
        if (data.image_paraph) {
            formData.append('image_paraph', data.image_paraph);
        }
        if (data.animated_signature) {
            formData.append('animated_signature', data.animated_signature);
        }

        return createSignatureApiCall<SignatureResource>('POST', `users/${userId}/signature`)({
            data: formData,
            ...options,
            headers: {
                ...options?.headers
            }
        });
    },

    deleteSignature: (userId: string, options?: ApiCallOptions) =>
        createSignatureApiCall<void>('DELETE', `users/${userId}/signature`)({...options})
};